import React from 'react'

export const bannerHTMLFormatter = (promoCode, amount) => (
  <span>
    USE CODE {promoCode} FOR {amount} OFF!
  </span>
)
